import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ProductContainerSkeleton from './productContainerSkeleton';

const useStyles = makeStyles(() => ({
  container: {
    '& > div:last-child': {
      marginBottom: 10,
    },
  },
}));

const ProductListSkeleton = ({ ...props }) => {
  const { mobile } = props;
  const classes = useStyles();
  return (
    <Box display="grid" gridRowGap="10px" className={classes.container}>
      <ProductContainerSkeleton mobile={mobile} />
      <ProductContainerSkeleton mobile={mobile} />
    </Box>
  );
};

ProductListSkeleton.propTypes = {
  mobile: PropTypes.bool,
};

export default ProductListSkeleton;
